import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, ButtonGroup, Skeleton } from '@mui/material';
import { MouseEvent, ReactNode, forwardRef } from 'react';
import FilterChipActionButton from './components/FilterChipActionButton/FilterChipActionButton';
import useFilterChipStyles from './filterChip.styles';
import { FilterChipAction } from './filterChip.types';

export type { FilterChipAction };

export interface FilterChipProps {
  primaryLabel: ReactNode;
  secondaryLabel?: ReactNode;
  onLabelClick?: (event: MouseEvent<HTMLElement>) => void;
  firstAction?: FilterChipAction;
  secondAction?: FilterChipAction;
  isLoading?: boolean;
  isActive?: boolean;
  title?: string;
  testId?: string;
}

const FilterChip = forwardRef<HTMLDivElement, FilterChipProps>(
  (
    {
      primaryLabel,
      secondaryLabel,
      onLabelClick,
      firstAction,
      secondAction,
      isLoading,
      isActive,
      title,
      testId,
    },
    ref,
  ) => {
    const { classes, cx } = useFilterChipStyles();

    return (
      <ButtonGroup
        ref={ref}
        size="small"
        disableRipple
        title={title}
        test-id={testId}
        className={cx(classes.container)}
      >
        {firstAction && <FilterChipActionButton action={firstAction} />}
        <Button
          fullWidth
          variant="text"
          color="secondary"
          className={cx(!firstAction && classes.insetStart, !secondAction && classes.insetEnd)}
          shape="square"
          onClick={onLabelClick}
          isActive={isActive}
        >
          {isLoading ? (
            <Skeleton width={100} variant="rectangular" animation="wave" />
          ) : (
            <Box className={classes.labelWrapper}>
              <Typography variant="body2" component="span">
                {primaryLabel}
              </Typography>
              {secondaryLabel != null && (
                <Typography variant="body2" component="span" sx={{ fontWeight: 'bold' }}>
                  {secondaryLabel}
                </Typography>
              )}
            </Box>
          )}
        </Button>
        {secondAction && <FilterChipActionButton action={secondAction} />}
      </ButtonGroup>
    );
  },
);

FilterChip.displayName = 'FilterChip';
export default FilterChip;
